import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';

const MARKETS_USING_PLAIN_VALUES = ['fr-FR'];

export const enum WeddingWebsiteDateFormat {
  Plain = 'plain',
  Ordinal = 'ordinal',
}

export const useGetWeddingWebsiteDateFormat = () => {
  const market = useMarket();

  return MARKETS_USING_PLAIN_VALUES.includes(market.locale)
    ? WeddingWebsiteDateFormat.Plain
    : WeddingWebsiteDateFormat.Ordinal;
};
